window.$ = window.jQuery = require("jquery");
require("form-serializer")
require("./validation");
const { $err } = require("./error-manager");

export function AccountManager() {
    var self = this;
    self.url = window.jrConfig.jrApiUrl + "/account/";
    self.catpcha = false;

    function resetModalForms() {
        $(".account-error-container").html("");
        $("#genericModal input").val(null);
        if (self.loginForm) {
            self.loginForm.resetForm();
        }
        if (self.registerForm) {
            self.registerForm.resetForm();
        }
    }

    self.showModal = function(ev, tab, url, context) {
        if (url) {
            $("#genericModal")
                .find(".modal-content")
                .html("");
            $("#genericModal")
                .find(".modal-content")
                .load(url, function() {
                    $('#genericModal input[name="context"]').val(context);

                    $('#genericModal a[data-toggle="tab"]').on("shown.bs.tab", resetModalForms);

                    if (self.catpcha) {
                        self.recaptchaLoaded()
                    } else {
                        self.catpcha = true;
                        const s = document.createElement("script");
                        s.setAttribute(
                            "src",
                            "https://www.google.com/recaptcha/api.js?onload=accountRecaptchaLoaded&render=explicit"
                        );
                        s.async = true;
                        s.defer = true;
                        document.body.appendChild(s);
                    }

                    self.addValidation();

                    $("#genericModal").modal();
                    $('#genericModal a[href="#' + tab + '"]').tab("show");
                    resetModalForms();
                });
        }

        ev.preventDefault();
        return false;
    };

    self.recaptchaLoaded = function() {
        console.log(window.grecaptcha)
        if (window.grecaptcha) {
            window.grecaptcha.render('register_recaptcha')
        }
    };

    self.bind = function() {
        $(".account-register")
            .unbind("click")
            .click(function(ev) {
                return self.showModal(
                    ev,
                    "register",
                    $(this).data("content"),
                    $(this).data("context")
                );
            });

        $(".account-login")
            .unbind("click")
            .click(function(ev) {
                return self.showModal(
                    ev,
                    "login",
                    $(this).data("content"),
                    $(this).data("context")
                );
            });

        $(".account-logout")
            .unbind("click")
            .click(function(ev) {
                self.logout(function() {
                    window.location.reload();
                });
                ev.preventDefault();
                return false;
            });
        self.addValidation();
    };

    self.addValidation = function() {
        self.loginForm = $('form[name="jrLoginForm"]:not([data-validator])').validate({
            submitHandler: function(form) {
                var data = $(form).serializeObject();
                self.login(data, function() {
                    window.location.reload();
                });
            }
        });

        self.registerForm = $('form[name="jrRegistrationForm"]:not([data-validator])').validate({
            submitHandler: function (form) {
                var data = $(form).serializeObject()
                if ($(form).has("#register_recaptcha").length) {
                    data = $.extend(
                        true,
                        data,
                        {'g-recaptcha-response': window.grecaptcha.getResponse()}
                    )
                }
                self.register(data, function () {
                    window.location.reload()
                })
            },
            rules: {
                password: {
                    minlength: 6
                },
                password_confirmation: {
                    equalTo: "#password"
                }
            }
        });
    };

    self.unsubscribeForm = $('form[name="unsubscribe"]:not([data-validator])').validate({
        submitHandler: function(form) {
            var data = $(form).serializeObject();
            self.unsubscribe(data, function() {
                $(form).hide();
                $(".alert-success").show();
            });
        }
    });

    self.login = function(data, success, error) {
        self.post(
            "login",
            data,
            function(res) {
                if (success) {
                    success(res);
                }
            },
            error
        );
    };

    self.logout = function(success, error) {
        self.post(
            "logout",
            {},
            function(res) {
                if (success) {
                    success(res);
                }
            },
            error
        );
    };

    self.register = function(data, success, error) {
        self.post(
            "register",
            data,
            function(res) {
                if (success) {
                    success(res);
                }
            },
            error
        );
    };

    self.unsubscribe = function(data, success, error) {
        self.post(
            "unsubscribe",
            data,
            function(res) {
                if (success) {
                    success(res);
                }
            },
            error
        );
    };

    self.post = function(action, data, success, error) {
        $("#genericModal button, #genericModal input").attr("disabled", "disabled");
        $(".account-error-container").html("");
        data = data || {};
        $.ajax({
            dataType: "json",
            url: self.url + action,
            method: "POST",
            data: data,
            success: function(res) {
                $("#genericModal button, #genericModal input").removeAttr("disabled");
                if (res) {
                    if (success) {
                        success(res);
                    }
                }
            },
            error: function(err) {
                $("#genericModal button, #genericModal input").removeAttr("disabled");
                var handled = error ? error(err) : false;
                if (!handled) {
                    $err.ajaxError(err, ".account-error-container");
                }
            }
        });
    };

    jQuery.ready.then(function() {
        self.bind();
    });
}

export const $am = new AccountManager();

window.accountRecaptchaLoaded = $am.recaptchaLoaded;
